// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6387":"31d6cfe0","9616":"491d0f01"}[chunkId] + ".chunk.css";
};